module.exports = __webpack_public_path__ + "img/sign-in-alt-solid.f926bad5.svg";